type SearchRadiusSelectItem = { label: `+${number}`; id: number };

const defaultRadius: SearchRadiusSelectItem = {
  label: '+0',
  id: 0,
};

export const extendedRadiusValuesMetric: SearchRadiusSelectItem[] = [
  defaultRadius,
  { label: '+1', id: 1 },
  { label: '+2', id: 2 },
  { label: '+5', id: 5 },
  { label: '+10', id: 10 },
  { label: '+20', id: 20 },
  { label: '+50', id: 50 },
  { label: '+100', id: 100 },
];

export const extendedRadiusValuesImperial: SearchRadiusSelectItem[] = [
  defaultRadius,
  { label: '+0.6', id: 1 },
  { label: '+1.2', id: 2 },
  { label: '+3', id: 5 },
  { label: '+6', id: 10 },
  { label: '+12', id: 20 },
  { label: '+30', id: 50 },
  { label: '+60', id: 100 },
];
